exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_object-gops.js
// module id = 118
// module chunks = 0